module.exports = __webpack_public_path__ + "img/heating-type-01-label-en.asset.187f99f8.svg";